<template>
  <el-dialog
    title="学员设置"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <el-form
      ref="settingsForm"
      :model="formData"
      :rules="formRules"
      label-width="140px"
    >
      <el-divider content-position="left">学习设置</el-divider>

      <el-form-item label="每日学习目标" prop="dailyTarget">
        <el-input-number
          v-model="formData.dailyTarget"
          :min="10"
          :max="500"
          :step="10"
          controls-position="right"
        />
        <span style="margin-left: 10px; color: #909399">个单词/天</span>
      </el-form-item>

      <el-form-item label="每日复习目标" prop="dailyReviewTarget">
        <el-input-number
          v-model="formData.dailyReviewTarget"
          :min="10"
          :max="500"
          :step="10"
          controls-position="right"
        />
        <span style="margin-left: 10px; color: #909399">个单词/天</span>
      </el-form-item>

      <el-form-item label="学习提醒时间" prop="reminderTime">
        <el-time-picker
          v-model="formData.reminderTime"
          format="HH:mm"
          value-format="HH:mm"
          placeholder="选择时间"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="启用学习提醒" prop="enableReminder">
        <el-switch v-model="formData.enableReminder" />
      </el-form-item>

      <el-divider content-position="left">测试设置</el-divider>

      <el-form-item label="自动测试频率" prop="testFrequency">
        <el-select
          v-model="formData.testFrequency"
          placeholder="请选择测试频率"
          style="width: 100%"
        >
          <el-option label="每天" value="daily" />
          <el-option label="每周" value="weekly" />
          <el-option label="每月" value="monthly" />
          <el-option label="不自动测试" value="never" />
        </el-select>
      </el-form-item>

      <el-form-item label="测试题目数量" prop="testQuestionCount">
        <el-input-number
          v-model="formData.testQuestionCount"
          :min="10"
          :max="100"
          :step="10"
          controls-position="right"
        />
        <span style="margin-left: 10px; color: #909399">道题</span>
      </el-form-item>

      <el-divider content-position="left">其他设置</el-divider>

      <el-form-item label="显示词根词缀" prop="showWordRoot">
        <el-switch v-model="formData.showWordRoot" />
      </el-form-item>

      <el-form-item label="显示例句" prop="showExampleSentence">
        <el-switch v-model="formData.showExampleSentence" />
      </el-form-item>

      <el-form-item label="启用发音" prop="enablePronunciation">
        <el-switch v-model="formData.enablePronunciation" />
      </el-form-item>

      <el-form-item label="学习模式" prop="learningMode">
        <el-radio-group v-model="formData.learningMode">
          <el-radio label="easy">简单模式</el-radio>
          <el-radio label="normal">标准模式</el-radio>
          <el-radio label="hard">困难模式</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">
        保 存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'StudentSettingsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    studentData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      submitting: false,
      formData: {
        dailyTarget: 50,
        dailyReviewTarget: 100,
        reminderTime: '19:00',
        enableReminder: true,
        testFrequency: 'weekly',
        testQuestionCount: 30,
        showWordRoot: true,
        showExampleSentence: true,
        enablePronunciation: true,
        learningMode: 'normal',
      },
      formRules: {
        dailyTarget: [
          { required: true, message: '请设置每日学习目标', trigger: 'blur' },
        ],
        dailyReviewTarget: [
          { required: true, message: '请设置每日复习目标', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  methods: {
    ...mapActions('student', ['updateStudentSettings']),

    /**
     * 对话框打开时
     */
    handleOpen() {
      if (this.studentData && this.studentData.settings) {
        // 加载学员已有的设置
        this.formData = { ...this.studentData.settings };
      } else {
        // 使用默认设置
        this.resetForm();
      }
    },

    /**
     * 关闭对话框
     */
    handleClose() {
      this.dialogVisible = false;
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.formData = {
        dailyTarget: 50,
        dailyReviewTarget: 100,
        reminderTime: '19:00',
        enableReminder: true,
        testFrequency: 'weekly',
        testQuestionCount: 30,
        showWordRoot: true,
        showExampleSentence: true,
        enablePronunciation: true,
        learningMode: 'normal',
      };
    },

    /**
     * 提交表单
     */
    handleSubmit() {
      this.$refs.settingsForm.validate(async (valid) => {
        if (!valid) {
          return false;
        }

        this.submitting = true;
        try {
          await this.updateStudentSettings({
            studentId: this.studentData.id,
            settings: this.formData,
          });
          this.$message.success('保存设置成功');
          this.$emit('success');
          this.handleClose();
        } catch (error) {
          console.error('保存设置失败:', error);
          this.$message.error('保存设置失败');
        } finally {
          this.submitting = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.el-divider {
  margin: 20px 0;
}
</style>
